import type { FaireProductEntity } from "../../entity_types/product";

export const p_8tj9kd673j: FaireProductEntity = {
  token: "p_8tj9kd673j",
  type: "product",
  name: "RE:usable Sponges (Set of 3) - RJW Glitz",
  brandToken: "b_ci67w2i6k6",
  brandName: "Once Again Home Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/b0016c64ec24fe3c152bfd0afd9c485d68e7359af568e3c36c2217fadd16b0f6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1e1c4af4413d9c549c3c393f789e003b7c8ed770101ce2dbbb448636555f6925.jpeg",
  ],
  priceDollars: 12.47,
  description:
    "We're excited to announce our latest collaboration with Rebecca Jane Woolbright! Together, we've created something truly special - re:usable soonges that feature an amazing prints for a unique and stylish look.\nGet ready to have your mind blown! Our RE:usable Sponge is not your average cleaning companion. Not only is it tough enough to tackle any mess you throw its way, but it also has a secret weapon - a charcoal-infused center that keeps it fresher than a daisy in a field of roses. \nAnd when it starts to look a bit worn out from all the cleaning action, just toss it in a mesh bag and let your washing machine do the dirty work. Easy peasy, lemon squeezy!",
  tags: [],
  msrpDollars: 24.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:55.257Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
